import { render, staticRenderFns } from "./ModalFeedback.vue?vue&type=template&id=09dcf570&"
import script from "./ModalFeedback.vue?vue&type=script&lang=js&"
export * from "./ModalFeedback.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports